import { render, staticRenderFns } from "./DepartmentLists.vue?vue&type=template&id=d4d5d4ac&"
import script from "./DepartmentLists.vue?vue&type=script&lang=js&"
export * from "./DepartmentLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports